import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const FacetRangeSlider = loadable(() =>
  import(/* webpackChunkName: "range-slider" */ '../attributes/facet_range_slider')
);

const FacetVideoLength = ({ facets, panelId, context }) => {
  const facet = facets.video_length[0];
  if (!facet) {
    return null;
  }

  const getRangeValues = (duration) => {
    if (duration.id && duration.active) {
      return duration.id.split('-');
    }

    return duration.defaults;
  };

  const getHeaderText = (value) => {
    let totalSeconds = value;
    const defaultHours = 1;

    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    let text = '';
    if (hours > 0) {
      if (hours === defaultHours) {
        text += `${hours}+ hr`;
      } else {
        text += `${hours} hr`;
      }
    }
    if (hours > 0 && hours !== 1) {
      text += `s`;
    }
    if (minutes > 0) {
      text += ` ${minutes} min`;
    }
    if (minutes > 0 && minutes !== 1) {
      text += `s`;
    }
    if (seconds > 0 || (seconds === 0 && minutes === 0 && hours === 0)) {
      text += ` ${seconds} sec`;
      if (seconds !== 1) {
        text += `s`;
      }
    }
    return text.trim();
  };

  const rangeValues = getRangeValues(facet);
  const minValue = parseInt(rangeValues[0], 10);
  const maxValue = parseInt(rangeValues[1], 10);
  const headerMin = `Min (${getHeaderText(minValue)})`;
  const headerMax = `Max (${getHeaderText(maxValue)})`;

  const defaultRange = (e) => {
    const duration = facets.video_length;
    const { defaults } = duration[0];

    return (
      e.value[0] === parseInt(defaults[0], 10) && e.value[1] === parseInt(defaults[1], 10)
    );
  };

  const handleChange = (e) => {
    const storeFacet = context.getStore('FacetStore').get('video_length')[0];
    storeFacet.active = !!defaultRange(e);
    storeFacet.id = `${e.value[0]}-${e.value[1]}`;
    storeFacet.onClearAll = false;

    if (!storeFacet.disabled && !storeFacet.locked) {
      context.executeAction(window.LP.module('Searches').SearchActions.toggleFacet, {
        facet: storeFacet
      });
    }
  };

  return (
    <FacetRangeSlider
      idSuffix={'video-length-slider'}
      minValue={minValue}
      maxValue={maxValue}
      defaultMin={parseInt(facet.defaults[0], 10)}
      defaultMax={parseInt(facet.defaults[1], 10)}
      headerMin={headerMin}
      headerMax={headerMax}
      active={facet.active}
      range={true}
      step={60}
      panelId={panelId}
      tooltip_split={true}
      formatter={getHeaderText}
      onClearAll={facet.onClearAll}
      onChange={handleChange}
    />
  );
};

FacetVideoLength.propTypes = {
  facets: PropTypes.object,
  panelId: PropTypes.string,
  context: PropTypes.object
};

export default FacetVideoLength;
